import { SettingsCard, TextField, ToggleField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function OdemeBanka({ settings, update }: SettingsTabProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SettingsCard
        title="Havale / EFT Bilgileri"
        description="Öğrencilerin havale ile ödeme yaparken göreceği banka hesap bilgileri."
      >
        <div className="space-y-4">
          <TextField
            label="Banka Adı"
            value={settings.bankName}
            onChange={(v) => update({ bankName: v })}
            placeholder="Örn: Ziraat Bankası"
          />
          <TextField
            label="Hesap Sahibi"
            value={settings.bankAccountName}
            onChange={(v) => update({ bankAccountName: v })}
            placeholder="Örn: DersDinle Eğitim A.Ş."
          />
          <TextField
            label="IBAN"
            value={settings.bankIban}
            onChange={(v) => update({ bankIban: v })}
            placeholder="TR00 0000 0000 0000 0000 0000 00"
          />
        </div>
      </SettingsCard>

      <SettingsCard
        title="Ödeme Yöntemleri"
        description="Öğrencilere sunulacak ödeme yöntemlerini yönet."
      >
        <div className="space-y-3">
          <ToggleField
            label="PayTR (Kredi Kartı)"
            description="PayTR iFrame ile kredi kartı ödemesi al. PayTR hesabındaki Mağaza No, API Anahtarı ve Gizli Anahtar bilgileri gereklidir."
            checked={settings.paytrEnabled}
            onChange={(v) => update({ paytrEnabled: v })}
          />
          <div className="rounded-md bg-accent-100/70 px-4 py-3 text-xs text-accent-900">
            <i className="ri-bank-card-line mr-1" aria-hidden="true"></i>
            Havale/EFT yöntemi her zaman aktiftir; banka bilgileri sol taraftan doldurulur.
          </div>
        </div>
      </SettingsCard>
    </div>
  );
}